import React from 'react';
import './Footer.css';
import { Link } from "react-router-dom";
import { Container, Row, Col} from "react-bootstrap";

import US from "../../../assets/images/Flags/US.png";
import BR from "../../../assets/images/Flags/BR.png"
import NL from "../../../assets/images/Flags/NL.png"
import ID from "../../../assets/images/Flags/ID.jpg";
import CA from "../../../assets/images/Flags/CA.png"
import MX from "../../../assets/images/Flags/MX.png"
import CO from "../../../assets/images/Flags/CO.png"
import MY from "../../../assets/images/Flags/MY.png"
import UK from "../../../assets/images/Flags/UK.png"
import AR from "../../../assets/images/Flags/AR.png"
import AU from "../../../assets/images/Flags/AU.png"
import KR from "../../../assets/images/Flags/KR.png"
import SG from "../../../assets/images/Flags/SG.png"
import FR from "../../../assets/images/Flags/FR.png"
import IN from "../../../assets/images/Flags/IN.png"
import PE from "../../../assets/images/Flags/PE.png"
import HK from "../../../assets/images/Flags/HK.png"
import DE from "../../../assets/images/Flags/DE.png"
import CL from "../../../assets/images/Flags/CL.png"
import PH from "../../../assets/images/Flags/PH.png"
import TH from "../../../assets/images/Flags/TH.png"
import IT from "../../../assets/images/Flags/IT.png"
import PL from "../../../assets/images/Flags/PL.png"
import TR from "../../../assets/images/Flags/TR.png"
import ES from "../../../assets/images/Flags/ES.png"
import JP from "../../../assets/images/Flags/JP.png"
import TW from "../../../assets/images/Flags/TW.png"
import VN from "../../../assets/images/Flags/VN.png"

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <section className="get-in-touch hpsection">
        <div className="text-center">
          <h2>Get in touch</h2>
          <p>For any questions, please email us at{" "}
            <a href="mailto:support@torfacts.com">support@torfacts.com</a>
          </p>
        

        </div>
        <Container style={{"width":"80%"}}>
          <Row>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={US} className="git" alt="contact" loading="lazy" /> United States</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={BR} className="git" alt="contact" loading="lazy" /> Brazil</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={NL} className="git" alt="contact" loading="lazy" /> NetherLand</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={ID} className="git" alt="contact" loading="lazy" /> Indonesia</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={CA} className="git" alt="contact" loading="lazy" /> Canada</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={MX} className="git" alt="contact" loading="lazy" /> Mexico</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={CO} className="git" alt="contact" loading="lazy" /> Colombia</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={MY} className="git" alt="contact" loading="lazy" /> Malaysia</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={UK} className="git" alt="contact" loading="lazy" /> United Kingdom</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={AR} className="git" alt="contact" loading="lazy" /> Argentina</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={KR} className="git" alt="contact" loading="lazy" /> Korea</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={SG} className="git" alt="contact" loading="lazy" /> Singapore</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={FR} className="git" alt="contact" loading="lazy" /> France</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={AU} className="git" alt="contact" loading="lazy" /> Australia</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={PE} className="git" alt="contact" loading="lazy" /> Peru</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={HK} className="git" alt="contact" loading="lazy" /> Hong Kong</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={DE} className="git" alt="contact" loading="lazy" /> Germany</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={IN} className="git" alt="contact" loading="lazy" /> India</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={PH} className="git" alt="contact" loading="lazy" /> Philippine</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={TH} className="git" alt="contact" loading="lazy" /> Thailand</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={IT} className="git" alt="contact" loading="lazy" /> Italy</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={CL} className="git" alt="contact" loading="lazy" /> Chile</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={PL} className="git" alt="contact" loading="lazy" /> Poland</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={TR} className="git" alt="contact" loading="lazy" /> Turkey</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={ES} className="git" alt="contact" loading="lazy" /> Spain</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={JP} className="git" alt="contact" loading="lazy" /> Japan</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={TW} className="git" alt="contact" loading="lazy" /> Taiwan</p>
          </Col>
          <Col lg={3} md={3} sm={4} xs={6}>
            <p className='footerFlags'><img src={VN} className="git" alt="contact" loading="lazy" /> Vietnam</p>
          </Col>

        </Row>
        </Container>
        
      </section>

      <nav className="footer-links">
        <Link to="/FAQ" className='footerlinks'>FAQs</Link> 
        &nbsp;&nbsp; | &nbsp;&nbsp; 
        <Link to="/privacy-policy" className='footerlinks'>Privacy Policy</Link> 
        &nbsp;&nbsp; | &nbsp;&nbsp; 
        <Link to="/terms-and-conditions" className='footerlinks'>T&C</Link>
        &nbsp;&nbsp; | &nbsp;&nbsp; 
        <Link to="/releases" className='footerlinks'>Releases</Link>
      </nav>

      <footer>
        <p>Copyright © {currentYear} Torfacts. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Footer;
